import { IApplicationState } from '../../types/redux';

export function isFloorPlanEnabled(state: IApplicationState) {
  return state.floorPlan.isEnabled;
}
